<template>
<div class="page-wrapper">
	<div class="page page-support">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title text-center">{{ $t('Welcome') }}, {{ user.name }}</h1>
			</div>
			<div class="page-content">
				<!-- Username -->
				<!-- <div class="welcome box box--primary" v-if="step === 'username'">
					<div class="welcome__title">{{ $t('Create Username') }}</div>
					<div class="welcome__description">
						<div>{{ $t('Define your username toti = this.identityCard;
							dentify your products') }}</div>
						<small>{{ $t('Can be changed later in Profile Settings') }}</small>
					</div>
					<div class="welcome__content">
						<div class="form-group mb-5">
							<div class="input-group">
								<input type="text" class="input form-control" placeholder="Your username..." :class="{ 'error': isUsernameError }" @input="onUsernameChange" v-model="username">
								<div class="input-group-append">
									<span class="input-group-text">.{{ mainUrl }}/your-product</span>
								</div>
							</div>
							<div class="field-success d-flex" v-if="!isCheckingUsername && username !== '' && !isUsernameError"><i class="material-icons">check</i>{{ $t('Username is available') }}</div>
							<div class="field-error" v-if="!isCheckingUsername && isUsernameError">{{ $t('Sorry, username is not available') }}</div>
							<div class="field-info" v-if="isCheckingUsername">{{ $t('Checking availability') }}...</div>
						</div>
					</div>
					<div class="welcome__footer">
						<div class="welcome__info">{{ $t('Step 1 of 3') }}</div>
						<div class="welcome__next">
							<button type="buttom" class="btn btn-primary" :class="[{ 'is-loading': isUpdatingUsername }]" :disabled="isUsernameError || username === ''" @click="updateUsername">
								<span>{{ $t('Next') }}</span><i class="material-icons">chevron_right</i>
							</button>
						</div>
					</div>
				</div> -->

				<!-- Bank Accounts -->
				<div class="welcome box box--primary" v-if="step === 'bank'">
					<div class="welcome__title">{{ $t('Add Bank Accounts') }}</div>
					<div class="welcome__description">
						<div>{{ $t('Will be shown when customer success submitting an order') }}</div>
						<small>{{ $t('Can be changed later in Profile') }}</small>
					</div>
					<div class="welcome__content">
						<div class="form-group">
							<bank-accounts :accounts="bankAccounts"></bank-accounts>
						</div>
						<div class="form-group mb-5">
							<div class="text-right">
								<button type="button" class="integration-app-button btn btn-primary" @click="isShowAddBank = true">+ {{ $t('Add Bank Account') }}</button>
							</div>
						</div>
					</div>
					<div class="welcome__footer">
						<div class="welcome__info">{{ $t('Step 1 of 2') }}</div>
						<div class="welcome__next">
							<button type="buttom" class="btn btn-primary" @click="nextStep()">
								<span>{{ $t('Next') }}</span><i class="material-icons">chevron_right</i>
							</button>
						</div>
					</div>
				</div>

				<!-- Seller Address-->
				<seller-address v-if="step === 'seller-address'" @set-step="setStep" />

				<!-- ID Card -->
				<div class="welcome box box--primary" v-if="step === 'identity'">
					<div class="welcome__title">{{ $t('Upload ID Card') }}</div>
					<div v-if="identityCard.status === 'rejected'" class="alert alert-danger" role="alert">
						<strong>{{ $t('ID Card Rejected :') }}</strong> {{ identityCard.reject_note }}
					</div>
					<div v-else class="welcome__description">
						<!-- <div>{{ $t('Upload a photo of your ID Card to activate your ostock account.') }}</div> -->
						<div>Upload foto selife bersama kartu identitas KTP atau SIM untuk memverifikasi data diri.</div>

						<div class="ilustration mt-2">
							<label class="text-bold">Contoh Selfie Dengan KTP / SIM</label>
							<img class="img-fluid rounded" src="/img/ktp-illustration.png" alt="KTP Ilustration">
						</div>
					</div>
					<div class="welcome__content">
						<upload-identity @uploaded="onUploadedIdentity" />
					</div>
					<div class="welcome__footer">
						<div class="welcome__info">{{ $t('Step 2 of 2') }}</div>
						<div class="welcome__next">
							<!-- <button type="buttom" class="btn btn-warning mr-2" :class="{'is-loading': isSavingIdentity}" @click="skipIdentity" v-if="step === 'identity'">
								<span>Nanti Saja</span><i class="material-icons">chevron_right</i>
							</button> -->
							<button type="buttom" class="btn btn-primary" :class="{'is-loading': isSavingIdentity}" @click="nextStep()">
								<span>{{ $t('Next') }}</span><i class="material-icons">chevron_right</i>
							</button>
						</div>
					</div>
				</div>

				<!-- Tutorial -->
				<!-- <div class="welcome box box--primary" v-if="step === 'tutorial'">
					<div class="welcome__title">{{ $t('Get Started') }}</div>
					<div class="welcome__description">
						<div>{{ $t('Know more about Ostock, Check out the') }} <a href="https://help.ostock.id/tutorial/" target="_blank"><b>{{ $t('Tutorials') }}</b></a></div>
					</div>
					<div class="welcome__footer">
						<div class="welcome__info">{{ $t('Step 2 of 3') }}</div>
						<div class="welcome__next">
							<button type="buttom" class="btn btn-primary" @click="step = 'done'">
								<span>{{ $t('Next') }}</span><i class="material-icons">chevron_right</i>
							</button>
						</div>
					</div>
				</div> -->

				<!-- Done -->
				<div class="welcome box box--primary" v-if="step === 'done'">
					<div class="welcome__title">{{ $t('Done') }}</div>
					<div class="welcome__description mb-5 d-flex">
						<div>{{ $t('Thank you, your data will be verified soon') }}</div>
						<div class="pc-done-icon"></div>
					</div>
					<div class="welcome__footer">
						<div class="welcome__info">{{ $t('Done') }}</div>
						<div class="welcome__next">
							<!-- <router-link to="/" class="btn btn-primary">{{ $t('Finish') }}</router-link> -->
						</div>
					</div>
				</div>

				<!-- Done Seller -->
				<div class="welcome box box--primary" v-if="step === 'done-seller'">
					<div class="welcome__title">{{ $t('Done') }}</div>
					<div class="welcome__description mb-5 d-flex">
						<div>{{ $t('Thank you, your account has been activated') }}</div>
						<div class="pc-done-icon"></div>
					</div>
					<div class="welcome__footer">
						<div class="welcome__next">
							<router-link to="/" class="btn btn-primary">{{ $t('Back to Home') }}</router-link>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>

	<div class="modals">
		<!-- T&C -->
		<tnc-modal ref="tncModal" @accept="nextStep" />

		<bank-accounts-modal
			:show="isShowAddBank"
			@close="isShowAddBank = false">
		</bank-accounts-modal>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BankAccounts from '@/components/BankAccounts.vue';
import BankAccountsModal from '@/components/BankAccountsModal.vue';
import TncModal from '@/components/TncModal.vue';
import UploadIdentity from '@/components/UploadIdentity.vue';
import SellerAddress from '@/components/welcome/SellerAddress.vue';
import userApi from '@/api/user';

export default {
	name: 'welcome',
	components: {
		BankAccounts,
		BankAccountsModal,
		TncModal,
		UploadIdentity,
		SellerAddress,
	},
	data() {
		return {
			mainUrl: 'ostock.id',
			step: 'bank',
			username: '',
			isUsernameError: false,
			isCheckingUsername: false,
			isUpdatingUsername: false,
			isShowAddBank: false,
			isSavingIdentity: false,
			isAgreementAccepted: false,
		};
	},
	methods: {
		...mapActions({
			setUsername: 'setUsername',
			addIdentityCard: 'addIdentityCard',
		}),
		checkUsername() {
			this.isCheckingUsername = true;
			const username = this.username;
			if (username && username.length > 2 && this.isValidSubdomain(username)) {
				const callback = () => {
					this.isUsernameError = false;
					this.isCheckingUsername = false;
				};
				const errorCallback = () => {
					this.isUsernameError = true;
					this.isCheckingUsername = false;
				};
				userApi.checkUsername(username, callback, errorCallback);
			} else {
				this.isUsernameError = true;
				this.isCheckingUsername = false;
			}
		},
		usernameParser(username) {
			return username.replace(/[^a-z0-9]/gi, '').trim();
		},
		onUsernameChange() {
			this.username = this.usernameParser(this.username);
			this.ooDelay(() => {
				this.checkUsername();
			}, 400);
		},
		updateUsername() {
			this.isUpdatingUsername = true;
			const callback = () => {
				this.isUpdatingUsername = false;
				this.setUsername(this.username);
				this.step = 'bank';
			};
			const errorCallback = () => {
				this.isUpdatingUsername = false;
			};
			userApi.updateUsername(this.username, callback, errorCallback);
		},
		nextStep() {
			if (this.$refs.tncModal.checkAgreement()) {
				// Seller Flow
				if (!this.isSupplier && this.step === 'bank') {
					if (this.isHasStoreAddress) {
						this.step = 'done-seller';
					} else {
						this.step = 'seller-address';
					}
				}

				// Supplier Flow
				if (this.isSupplier && this.step === 'bank' && this.bankAccounts.length > 0) {
					this.step = 'identity';
				}
				if (this.isSupplier && this.step === 'identity' && ((this.identityCard.image_url !== '' && this.identityCard.image_url_full !== '') || this.identityCard.status === 'skipped') && this.identityCard.status !== 'rejected') {
					this.step = 'done';
				}
			}
		},
		setStep(value) {
			this.step = value;
			this.nextStep();
		},
		skipIdentity() {
			this.updateIdentityCard('skipped');
			this.step = 'done';
		},
		onUploadedIdentity(value) {
			this.isSavingIdentity = value;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			bankAccounts: 'bankAccounts',
			identityCard: 'identityCard',
			isSupplier: 'isSupplier',
			isHasStoreAddress: 'isHasStoreAddress',
		}),
	},
	mounted() {
		this.nextStep();
	},
};
</script>
